import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth/auth.guard';
import { NOF_CONFIGURE_THRESHOLD_PERMISSION, NOF_TEAMS_CAMPAIGN_PERMISSION } from '@guards/auth/permissions';
import { campaignsGuard } from '@guards/campaigns/campaigns.guard';

export const HOME_PAGE: string = 'dashboard';
export const CAMPAIGN_LIST_PAGE: string = 'teams/campaign';

export const routes: Routes = [
  { path: '', redirectTo: HOME_PAGE, pathMatch: 'full' },
  {
    path: HOME_PAGE,
    loadComponent: () =>
      import('./page/dashboard/dashboard.page').then(
        (m) => m.DashboardPageComponent
      ),
  },
  {
    path: 'notifications',
    children: [
       {
        path: '',
        redirectTo: `/${HOME_PAGE}`,
        pathMatch: 'full',
      },
      {
        path: ':type',
        loadComponent: () =>
          import('./page/notification-list/notification-list.page').then(
            (m) => m.NotificationListPageComponent
          )
      }
    ],
  },
  {
    path: 'notification-detail',
    loadComponent: () =>
      import('./page/notification-detail/notification-detail.page').then(
        (m) => m.NotificationDetailPageComponent
      ),
  },
  {
    path: CAMPAIGN_LIST_PAGE,
    loadComponent: () =>
      import('./page/teams-campaign/teams-campaign-list/teams-campaign-list.page').then(
        (m) => m.TeamsCampaignListPage
      ),
    canActivate: [authGuard],
    data: { requiredPermissions: NOF_TEAMS_CAMPAIGN_PERMISSION }
  },
  {
    path: 'teams/campaign/create',
    loadComponent: () =>
      import('./page/teams-campaign/teams-campaign-creation/teams-campaign-creation.page').then(
        (m) => m.TeamsCampaignPageCreation
      ),
    canActivate: [authGuard],
    data: { requiredPermissions: NOF_TEAMS_CAMPAIGN_PERMISSION }
  },
  {
    path: 'teams/campaign/:campaignId',
    loadComponent: () =>
      import('./page/teams-campaign/teams-campaign-creation/teams-campaign-creation.page').then(
        (m) => m.TeamsCampaignPageCreation
      ),
    canActivate: [authGuard, campaignsGuard],
    data: { requiredPermissions: NOF_TEAMS_CAMPAIGN_PERMISSION }
  },
  {
    path: 'alerting/thresholds',
    loadComponent: () =>
      import('./page/configure-thresholds-page/configure-thresholds.page').then(
        (m) => m.ConfigureThresholdsPageComponent
      ),
    canActivate: [authGuard],
    data: { requiredPermissions: NOF_CONFIGURE_THRESHOLD_PERMISSION }

  },
  { path: '**', redirectTo: HOME_PAGE }
];
